import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-home-testimonials',
  templateUrl: './home-testimonials.component.html',
  styleUrls: ['./home-testimonials.component.scss']
})
export class HomeTestimonialsComponent {
  @Input() testimonials: any[] = [];
  @Input() currentTestimonialIndex: number = 0;
  @Input() isTransitioning: boolean = false;
  @Input() isAutoplayPaused: boolean = false;
  @Input() autoplayDuration: number = 5000;

  @Output() nextTestimonialEvent = new EventEmitter<void>();
  @Output() prevTestimonialEvent = new EventEmitter<void>();
  @Output() goToTestimonialEvent = new EventEmitter<number>();
  @Output() pauseAutoplayEvent = new EventEmitter<void>();
  @Output() resumeAutoplayEvent = new EventEmitter<void>();

  nextTestimonial(): void {
    this.nextTestimonialEvent.emit();
  }

  prevTestimonial(): void {
    this.prevTestimonialEvent.emit();
  }

  goToTestimonial(index: number): void {
    this.goToTestimonialEvent.emit(index);
  }

  pauseAutoplay(): void {
    this.pauseAutoplayEvent.emit();
  }

  resumeAutoplay(): void {
    this.resumeAutoplayEvent.emit();
  }

  getTransform(): number {
    // Check if we're in browser environment
    if (typeof window === 'undefined') {
      // Default for SSR
      const cardWidthWithGap = 280 + 24;
      return -(this.currentTestimonialIndex * cardWidthWithGap);
    }

    const containerWidth = window.innerWidth;
    let cardWidth = 280; // Desktop default

    // Responsive card width and count
    if (containerWidth < 768) {
      cardWidth = 300; // Mobile
    } else if (containerWidth < 1024) {
      cardWidth = 320; // Tablet
    } else {
      cardWidth = 280; // Desktop - show 4 cards
    }

    const cardWidthWithGap = cardWidth + 24; // 24px gap between cards
    return -(this.currentTestimonialIndex * cardWidthWithGap);
  }

  getExtendedTestimonials() {
    // Create endless effect by duplicating testimonials
    const extended = [...this.testimonials, ...this.testimonials, ...this.testimonials];
    return extended;
  }

  getCardTransform(index: number): string {
    // Add subtle 3D perspective effect on hover (handled by CSS :hover)
    return 'translateZ(0)';
  }

  getInitials(name: string): string {
    return name.split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  }

  getAvatarColor(index: number): string {
    const colors = [
      'avatar-blue', 'avatar-purple', 'avatar-pink', 'avatar-green',
      'avatar-orange', 'avatar-teal', 'avatar-red', 'avatar-indigo',
      'avatar-yellow', 'avatar-emerald'
    ];
    return colors[index % colors.length];
  }

  getCurrentDotIndex(): number {
    return this.currentTestimonialIndex % this.testimonials.length;
  }
}